import * as T from './types';
import { OnboardingInputType } from '../../../services/userOnboardingService/types';
import ServiceRoutingInterfaceV1 from './ServiceRoutingInterfaceV1';

export { createNoopServiceRoutingInterface } from './NoopInterface';

let serviceRoutingInterfaceV1: ServiceRoutingInterfaceV1;

export function getServiceRoutingInterfaceV1(): T.ServiceRoutingInterfaceType {
  return serviceRoutingInterfaceV1.getInterface();
}

export default async function initializeServiceRoutingInterfaceV1({
  onboardingInput
}: {
  onboardingInput: OnboardingInputType;
}): Promise<T.ServiceRoutingInterfaceType> {
  if (serviceRoutingInterfaceV1)
    return serviceRoutingInterfaceV1.getInterface();

  serviceRoutingInterfaceV1 = new ServiceRoutingInterfaceV1({
    onboardingInput
  });

  return serviceRoutingInterfaceV1.getInterface();
}
